import axios from 'axios';

const sendCovidReminder = async (appointmentId: string) => {
  await axios.post(`/covid19/appointment/${appointmentId}/reminder`);
};

export default sendCovidReminder;
